// extracted by mini-css-extract-plugin
export default {"OuterSection":"Services_OuterSection__7z+iV","griditem":"Services_griditem__zO+Iv","text":"Services_text__SZsCu","logo":"Services_logo__oduwY"};